<template>
    <b-table :fields="fields" :items="eventItems" primary-key="event" striped hover head-variant="light" show-empty>
        <template v-slot:empty>
            <p class="text-info">Aucun événement en cours.</p>
        </template>
        <template v-slot:cell(event)="data">
            <span v-if="eventExists(data.item.event)"><font-awesome-icon :icon="eventIcon(data.item.event)"/> {{ eventLabel(data.item.event)}}</span>
            <span v-else>{{ data.item.event }}</span>
        </template>
        <template v-slot:cell(startTime)="data">
            <abbr :title="data.item.startTime | moment('LL LTS')">{{data.item.startTime | moment("from") }}</abbr>
        </template>
        <template v-slot:cell(lastSeen)="data">
            <abbr :title="data.item.lastSeen | moment('LL LTS')">{{data.item.lastSeen | moment("from") }}</abbr>
        </template>
    </b-table>
</template>

<script>
    import {EVENTS} from "../events";

    export default {
        name: "EventsTable",
        props: {
            events: Array
        },
        data() {
            return {
                fields: [
                    {key: "event", label: "Événement"},
                    {key: "startTime", label: "Début"},
                    {key: "lastSeen", label: "Dernière remontée"}
                ]
            };
        },
        methods: {
            eventExists(key) {
                return key in EVENTS;
            },
            eventIcon(key) {
                return (EVENTS[key] || {}).icon;
            },
            eventLabel(key) {
                return (EVENTS[key] || {text: key}).text;
            },
            eventVariant(key) {
                return (EVENTS[key] || {}).color;
            }
        },
        computed: {
            eventItems() {
                return this.events.map(e => Object.assign({}, e, {_rowVariant: this.eventVariant(e.event)}));
            }
        }
    }
</script>

<style scoped>

</style>